<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    <div class="header">
        <span *ngIf="!editUser">{{'USER_DETAILS.addUser' | translate}}</span>
        <span *ngIf="editUser">{{'USER_DETAILS.editUser' | translate}}</span>
        
      <i class="material-icons" (click)='closeDialog("");'>clear</i>
    </div>
    <div class="section">
        <div class="addBody">
            <div class="bodyLeft">
                <div class="form">
                    <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'USER_DETAILS.userName' | translate}}</div>
                    <input class="form-input" [(ngModel)]="newUserData.user_name" type="text" />
                </div>
                <div class="form">
                    <div class="form-label">{{'USER_DETAILS.units' | translate}}</div>
                    <mat-select multiple [(ngModel)]="unitSelection">
                        <mat-option *ngFor="let unit of entities" (onSelectionChange)="selectUnit(unit, $event)"
                            [value]="unit.name">
                            {{unit.name}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="form">
                    <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'USER_DETAILS.mobile' | translate}}</div>
                    <input class="form-input" [(ngModel)]="newUserData.mobile" type="text" />
                </div>
                <div class="form">
                    <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'USER_DETAILS.email' | translate}}</div>
                    <input class="form-input" [(ngModel)]="newUserData.email_id" type="text" />
                </div>
            </div>

            <!-- <div class="form">
                <div class="form-label"><sup style="color: #E54131; font-weight: 900;">*</sup>{{'USER_DETAILS.password' | translate}}</div>
                <input type="password" class="form-input" [(ngModel)]="newUserData.password" />
            </div> -->
            <div class="bodyRight">
                <div class="form">
                    <div class="form-input form-button" (click)="openRolesModal();">
                        {{'USER_DETAILS.rolesFunctionalities' | translate}}
                    </div>
                </div>
                <app-roles class="roles" *ngIf="showRoles" (rolesToSend) = "getRolesFromChild($event)" [parentData] = "dataToSend"></app-roles>
            </div>
        </div>
      <div class="submitButton" (click)="submit()">
        <div class="button">
            {{'USER_DETAILS.submitButton' | translate}}
        </div>
      </div>
    </div>
  
  </div>
  